import { useSettings } from '@wu/widget-core';

const DEFAULT_PAGE_URL = 'https://elfsight.com';

export const useTextMessage = ({ message = '', withTags = false }) => {
  const { editMode, includePageURL } = useSettings();

  const textMessage = message.trim();
  const pageURL = editMode ? DEFAULT_PAGE_URL : window.location.href;

  if (withTags) {
    return textMessage.replaceAll('[page_url]', pageURL);
  }

  if (includePageURL) {
    return textMessage ? `${textMessage}\n\n${pageURL}` : pageURL;
  }

  return textMessage;
};
